import { REGIONS } from '../data/destinations';
import { useCatalog } from '../data/catalog';
import { useLang } from '../i18n';
import { useSEO } from '../seo';
import { PageHeader } from '../components/PageHeader';
import { Kicker, Reveal } from '../components/Reveal';
import { DestinationCard } from '../components/DestinationCard';

const STATUS_STYLE = {
  available: 'bg-eco-green text-white',
  partner_network: 'bg-eco-gold text-eco-deep',
  coming_soon: 'bg-eco-ink/40 text-white',
};

export default function DestinationsPage() {
  const { t } = useLang();
  const { destinations } = useCatalog();
  useSEO('Destinations | Eco Collection', 'Explore our destinations — local people, authentic experiences, remarkable places across Africa and the Indian Ocean.');

  return (
    <div data-testid="destinations-page">
      <PageHeader
        kicker={t('page.destinations.k')}
        title={t('page.destinations.t')}
        sub={t('page.destinations.s')}
      />
      <section className="bg-eco-cream py-16 md:py-24">
        <div className="mx-auto max-w-7xl space-y-16 px-5 md:px-8">
          {REGIONS.map((region) => {
            const regionDests = destinations.filter((d) => d.region === region.id);
            if (regionDests.length === 0) return null;
            return (
            <div key={region.id} data-testid={`region-${region.id}`}>
              <Reveal>
                <Kicker>{t(`region.${region.id}`)}</Kicker>
                <h2 className="mt-2 font-serif text-2xl font-semibold text-eco-ink">{t(`region.${region.id}`)}</h2>
              </Reveal>
              <div className="mt-8 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {regionDests.map((d, i) => (
                  <Reveal key={d.slug} delay={i * 0.1}>
                    <DestinationCard
                      destination={{ ...d, regionName: t(`region.${region.id}`) }}
                      testid={`destinations-page-card-${d.slug}`}
                      statusLabel={t(`dst.${d.status === 'partner_network' ? 'partner' : d.status}`)}
                      statusClass={STATUS_STYLE[d.status]}
                      ctaLabel={d.cta || t('nav.explore')}
                    />
                  </Reveal>
                ))}
              </div>
            </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
